<div class="{{theme}}">
    <mat-dialog-content>
        <div class="mt-3 mr-0">
            <div class="row">
                <div *ngFor="let disclaimer of disclaimers; let i = index" class="col-md-12 mt-2">
                    <input type="checkbox" (change)="onDisclaimerChange(disclaimer, $event.target.checked)" />{{disclaimer.disclaimerId}}. <strong>{{disclaimer.disclaimerTitle}} -</strong> {{disclaimer.disclaimerMessage}}
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <div id="admin" class="row mt-3 mx-auto">
            <span class="save-btn">
                <button type="button" class="btn btn-default btn-save" (click)="onSelect()">Ok</button>
            </span>
            <span class="ml-2">
                <button type="button" class="btn btn-secondary" [mat-dialog-close]="true" (click)="onCancel()">Cancel</button>
            </span>
        </div>
    </mat-dialog-actions>
</div>